import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_SERVER_ENDPOINT,
  withCredentials: true,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;

    if (status === 401 || status === 403) {
      window.location.href = "/";
      return;
    }

    return Promise.reject(error);
  }
);

// let isRefreshing = false;
// let failedQueue = [];

// const processQueue = (error = null) => {
//   failedQueue.forEach((prom) => {
//     if (error) prom.reject(error);
//     else prom.resolve();
//   });
//   failedQueue = [];
// };

// axiosInstance.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     const originalRequest = error.config;

//     if (originalRequest.url.includes("/auth/refresh-token")) {
//       return Promise.reject(error);
//     }

//     if (
//       (error.response?.status === 401 || error.response?.status === 403) &&
//       !originalRequest._retry
//     ) {
//       if (isRefreshing) {
//         return new Promise((resolve, reject) => {
//           failedQueue.push({ resolve, reject });
//         })
//           .then(() => axiosInstance(originalRequest))
//           .catch((err) => Promise.reject(err));
//       }

//       originalRequest._retry = true;
//       isRefreshing = true;

//       try {
//         await axios.post(
//           `${process.env.REACT_APP_SERVER_ENDPOINT}/auth/refresh-token`,
//           {},
//           { withCredentials: true }
//         );

//         processQueue();
//         isRefreshing = false;

//         return axiosInstance(originalRequest);
//       } catch (refreshError) {
//         processQueue(refreshError);
//         isRefreshing = false;

//         window.location.href = "/";

//         return Promise.reject(refreshError);
//       }
//     }

//     return Promise.reject(error);
//   }
// );

export default axiosInstance;
